import { styled } from "@mui/material/styles";

export const StyledPDFWrapper = styled("div")`
  max-width: 100%;
  width: 100%;
`;
